import { render, staticRenderFns } from "./PosterShare.vue?vue&type=template&id=44690400&scoped=true"
import script from "./PosterShare.vue?vue&type=script&lang=js"
export * from "./PosterShare.vue?vue&type=script&lang=js"
import style0 from "./PosterShare.vue?vue&type=style&index=0&id=44690400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44690400",
  null
  
)

export default component.exports